import { selectIsSpelombud } from '@common/selectors';
import europatipsmastarenLogo from '../images/europamastaren-logo.png';
import europatipsmastaren from '../images/europamastaren.png';
const tipsSmFeauture = svs.core.detect.feature('ft-tips-sm');
const tipsSmMetadata = tipsSmFeauture ? {
  '/tips-sm': {
    label: 'Tips-SM',
    navBar: {
      style: {
        color: '#fff',
        backgroundColor: '#142E4F'
      },
      activeStyle: {
        color: 'white',
        'border-bottom-color': '#fff'
      }
    },
    useIsAllowed: () => {
      return ReactRedux.useSelector(selectIsSpelombud);
    }
  }
} : {};
const europatipsmastarenFeauture = svs.core.detect.feature('ft-europamastaren');
const europatipsmastarenMetadata = europatipsmastarenFeauture ? {
  '/europatipsmastaren': {
    label: 'Europatipsmästaren',
    header: {
      backgroundImage: europatipsmastaren,
      logo: europatipsmastarenLogo
    },
    navBar: {
      style: {
        color: '#fff',
        backgroundColor: '#004D1D'
      },
      activeStyle: {
        color: 'white',
        'border-bottom-color': '#fff'
      }
    },
    useIsAllowed: () => {
      return ReactRedux.useSelector(selectIsSpelombud);
    }
  }
} : {};
const metadata = {
  title: 'Tävlingar',
  routes: {
    '/saljtavlingar': {
      label: 'Säljtävlingar'
    },
    '/vinnargalan': {
      label: 'Vinnargalan',
      navBar: {
        style: {
          color: '#5F0016',
          backgroundColor: '#fae4be'
        },
        activeStyle: {
          color: '#5F0016',
          'border-bottom-color': '#5F0016'
        }
      }
    },
    ...tipsSmMetadata,
    ...europatipsmastarenMetadata
  }
};
export { metadata };